// Theme LuckyGirl678

import { Roboto, Noto_Sans_Thai } from "next/font/google";
import { alpha, createTheme } from "@mui/material/styles";
import "../theme.d";

const roboto = Roboto({
  weight: ["300", "400", "500", "700"],
  subsets: ["latin"],
  display: "swap",
});

const notoSansThai = Noto_Sans_Thai({
  weight: ["300", "400", "500", "700"],
  subsets: ["latin"],
  display: "swap",
});

const   preset41 = createTheme({
  name: "  preset41",
  config: {
    // แสดงปุ่มฝากถอนในกระเป๋าหรือไม่ ถ้าเป็น true จะแสดงปุ่ม ถ้าเป็น false จะไม่แสดงปุ่มในกระเป๋า
    // แต่จะแสดงนอกกระเป๋าเงิน
    showDepositAndWithdrawInWallet: false,
    // โลโก้
    logo: {
      // ขนาดโลโก้
      height: 150,
      // ขนาดโลโก้ใน AppBar
      appBarHeight: 90,
      // ระยะห่างของโลโก้ใน AppBar
      appBarSpacing: 8,
    },
  },
  palette: {
    mode: "dark",
    // สีเส้น
    divider: alpha("#001c08", 0.4),
    // สีหลัก
    primary: {
      main: "#f2f2f2",
      contrastText: "#171203",
    },
    // สีลอง
    secondary: {
      main: "#7a0101",
      contrastText: "white",
    },
    background: {
      // สีพื้นหลัง
      default: "#3C2F2F",
      // สี Card
      //  paper: "#7a0101 ",
      // paper: "#A52A2A ",
      //  paper: "#4B2E2E",
      //  paper: "#3C2F2F ",

    },
  },
  backgroundImage: {
    // รูปพื้นหลัง
    body: "https://images-platform.sgp1.cdn.digitaloceanspaces.com/background/bg_chokdee69.png",
    // ความทึบของรูปพื้นหลัง
    bodyOpacity: 0.4,
    // ขนาดรูปพื้นหลัง
    bodySize: "cover",
    // รูปแบบการวางรูปพื้นหลัง
    // backgroundAttachment: "fixed",
  },
  mineColor: {
    // สีพื้นหลังแบบสว่าง
    "paper-soft": "#8B0000",
    // สีพื้นหลังแบบมืด
    "paper-deep": "#8B0000",
  },
  shape: {
    // ขนาดขอบมน
    borderRadius: 16,
  },
  gradient: {
    // สีกระเป๋าตอนไม่ได้รับโบนัส
    100: "linear-gradient(330deg, rgba(174,0,26,1) 32%, rgba(133,0,20,1) 100%)",
    // สีกระเป๋าตอนรับโบนัส
    200: "linear-gradient(45deg, #C1272D 30%, #D4AF37 90%)",
    // สี Card

    300: "linear-gradient(90deg, #8B0000 ,rgb(172, 18, 23) , #8B0000)",
    // 300: "linear-gradient(90deg, #8B0000 30%,rgb(124, 40, 31) 60%, #8B0000 80%)",
    // สี Appbar
    // 400: "linear-gradient(45deg, #C1272D 50%, #B03A2E 80%, #D4AF37 90%)",
    400: "linear-gradient(45deg, #8B0000 40%, #7a0101)",

    500: "linear-gradient(45deg, #8B0000 40%, #7a0101)",

  },
  wheel: {
    // ขอบกงล้อ
    borderColor: "#1f1919",
    segment: {
      // สีกงล้อ 1
      fillStyle1: "#d8d8d8",
      // สีกงล้อ 2
      fillStyle2: "#b71d11 ",
    },
  },
  typography: {
    // ฟอนต์
    fontFamily: [notoSansThai.style.fontFamily, roboto.style.fontFamily].join(
      ","
    ),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          borderRadius: "10px",
          textTransform: "capitalize",
          ...(ownerState.variant === "contained" && {
            background:   preset41.palette.primary.main,
          }),
          ...(ownerState.variant === "outlined" && {
            color:   preset41.palette.primary.main,
            borderColor:   preset41.palette.primary.main,
          }),
        }),
      },
    },
  },
});

export default   preset41;
